<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="外卖单">
      <template>
        <el-form :inline="true" size="small" style="padding-top: 18px">
          <el-form-item label="门店">
            <el-select v-model="storeId" placeholder="请选择门店">
              <el-option
                v-for="item in storeManagement"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="downloadTodaySTakeawayOrder"
              >下载外卖单</el-button
            >
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="downloadMytLogisticsFee"
              >同步外卖运费</el-button
            >
          </el-form-item>
 

        </el-form>
      </template>
    </pageTitle>
    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @sortChange="sortChange"
      @dynamic="dynamic"
      @handleSelectionChange="handleSelectionChange"
      @batchCreation="handleBatchCreation"
    >
      <template v-slot:clickFarming="row">
        <div
          v-if="row.row.status == 0 && !row.row.user_name"
          class="button button_revoke"
          @click="clickFarming(row.row)"
        >
          <i class="iconfont icon-shuadandingdan"></i>刷单
        </div>

        <div
          v-if="row.row.status == 0 && !row.row.user_name"
          class="button button_revoke"
          @click="skip(row.row)"
        >
          <i class="iconfont icon-tiaoguo"></i>
          跳过
        </div>
      </template>
      <template v-slot:otherOperations>
        <el-button type="primary" size="small" @click="dynamic('batchCreation')"
          >批量建单</el-button
        >
        <div style="margin: 0 10px">
          <el-select
            v-model="accountId"
            size="small"
            placeholder="选择新运费账号"
          >
            <el-option
              v-for="item in accountList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="primary" size="small" @click="changeShippingFee"
            >批量更换</el-button
          >
        </div>
      </template>
      <template v-slot:additionalFeatures>
        <div class="procurementDataSummary procurementDataSummary2">
          <ul>
            <li>
              <div>
                <div class="summaryTitle">订单数量</div>
                <div class="today summaryLine">
                  <p>{{ summarizeData.order_total_num }}</p>
                </div>
              </div>
              <div class="subtotals">
                <p>美团：{{ summarizeData.mt_order_num }}</p>
                <p>饿了么：{{ summarizeData.elm_order_num }}</p>
                <p>POS机：{{ summarizeData.pos_order_num }}</p>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">订单金额</div>
                <div class="today summaryLine">
                  <p>{{ summarizeData.order_total_money | money }}</p>
                </div>
              </div>
              <div class="subtotals">
                <p>美团：{{ summarizeData.mt_total_money | money }}</p>
                <p>饿了么：{{ summarizeData.elm_total_money | money }}</p>
                <p>POS机：{{ summarizeData.pos_total_money | money }}</p>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">净毛利</div>
                <div class="today summaryLine">
                  <p>
                    {{ summarizeData.order_total_real_profit_money | money }}
                  </p>
                </div>
              </div>
              <div class="subtotals">
                <p>
                  美团：{{ summarizeData.mt_total_real_profit_money | money }}
                </p>
                <p>
                  饿了么：{{
                    summarizeData.elm_total_real_profit_money | money
                  }}
                </p>
                <p>
                  POS机：{{ summarizeData.pos_total_real_profit_money | money }}
                </p>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">平均每单运费</div>
                <div class="today summaryLine" style="">
                  <p>{{ summarizeData.order_total_avg_payfor_move | money }}</p>
                </div>
              </div>
              <div class="subtotals">
                <p>
                  总运费：{{ summarizeData.order_total_payfor_move | money }}
                </p>
                <p>美团：{{ summarizeData.mt_payfor_move | money }}</p>
                <p>饿了么：{{ summarizeData.elm_payfor_move | money }}</p>
              </div>
            </li>
            <li>
              <div>
                <div class="summaryTitle">刷单利润</div>
                <div class="today summaryLine">
                  <p>{{ summarizeData.sd_profit_money_total | money }}</p>
                </div>
              </div>
              <div class="subtotals">
                <p>订单：{{ summarizeData.sd_count_total }}</p>
                <p>收入：{{ summarizeData.sd_get_pay_price_total | money }}</p>
                <p>支出：{{ summarizeData.sd_pay_pay_price_total | money }}</p>
                <!-- 刷单总额悬浮明细 -->
                <div
                  class="sd-total-popover-trigger"
                  style="position: relative; display: flex; align-items: center; margin-top: 6px;"
                  @mouseenter="showSdTotalPopover = true"
                  @mouseleave="showSdTotalPopover = false"
                >
                  <span style="cursor: pointer; color: #409EFF; margin-right: 6px;">
                    刷单总额
                  </span>
                  {{ summarizeData.sd_price_total | money }}

                  <div
                    v-if="showSdTotalPopover"
                    class="sd-total-popover"
                    @mouseenter="showSdTotalPopover = true"
                    @mouseleave="showSdTotalPopover = false"
                  >
                    <table>
                      <tr>
                        <td>刷单成本</td>
                        <td style="text-align: right;">{{ sd_total_cost | money }}</td>
                      </tr>
                      <tr>
                        <td>刷单运费</td>
                        <td style="text-align: right;">{{ sd_total_freight | money }}</td>
                      </tr>
                      <tr>
                        <td>刷单手续费</td>
                        <td style="text-align: right;">{{ sd_total_fee | money }}</td>
                      </tr>
                    </table>
                  </div>
                </div>


              </div>
            </li>
          </ul>
        </div>
        <div style="height: 20px"></div>
      </template>
      <template v-slot:order_sn="row">
        <el-link
          :type="row.row.is_red == 1 ? 'danger' : 'primary'"
          @click="preview(row.row)"
          >{{ row.row.order_sn }}</el-link
        >
      </template>
      <template v-slot:freight_platform="row">
        <span>
          <template v-if="row.row.order_type != 6">
            <template v-if="row.row.freight_platform == 1 || row.row.freight_platform == '1'">美团直送</template>
            <template v-else-if="row.row.freight_platform == 2 || row.row.freight_platform == '2'">麦芽田</template>
            <template v-else>其他</template>
          </template>
          <template v-else>--</template>
        </span>
      </template>
      <template v-slot:payfor_move="row">
        <el-input
          size="mini"
          v-model="row.row.payfor_move"
          placeholder="请输入运费支出"
        >
          <el-button
            slot="append"
            size="mini"
            @click="saveShippingCost(row.row, row.row.payfor_move)"
            plain
            >保存</el-button
          >
        </el-input>
      </template>
      <template v-slot:sd_fee="row">
        <el-input
          size="mini"
          v-model="row.row.sd_fee"
          placeholder="订单手续费"
        >
          <el-button
            slot="append"
            size="mini"
            @click="saveSdCost(row.row, row.row.sd_fee)"
            plain
            >保存</el-button
          >
        </el-input>
      </template>
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <div
            class="button button_revoke"
            v-if="row.row.status == 0 && !row.row.user_name"
            @click="creatSaleOrder(row.row)"
          >
            <i class="iconfont icon-chuangjian"></i>
            建单
          </div>
          <div
            v-if="row.row.status == 4 && !row.row.user_name"
            class="button button_revoke"
            @click="creatSaleOrder(row.row)"
          >
            <i class="iconfont icon-buchongxinxi"></i>
            补打
          </div>
          <!-- <div
          v-if="row.row.status == 0 && !row.row.user_name"
          class="button button_revoke"
          @click="clickFarming(row.row)"
        >
          <i class="iconfont icon-shuadandingdan"></i>刷单
        </div> -->

          <div
            v-if="row.row.status == 3"
            class="button button_revoke"
            @click="clickFarming(row.row)"
          >
            <i class="iconfont icon-shuadandingdan"></i>取消刷单
          </div>
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
    <!-- <Freigth :config="freightConfig" @close="closefreightConfig"></Freigth> -->

    <previewComponents
      @close="closeView"
      :acceptedParameters="previewParams"
    ></previewComponents>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  orderTakeoutGetList,
  mailAlert,
  orderTakeoutSetRefresh,
  orderTakeoutSetUnRefresh,
  orderTakeoutSetJump,
  orderTakeoutSetUnJump,
  upPayforMoveId,
  orderSellGetList,
  orderSellBatchAdd,
  orderTakeoutGetOne,
  setPayForMove,
  setPayForSdFee,
  doBatchAdd,
  pushYesterdayOrder,
  downloadMytLogisticsFeeData,
} from "@/api/sale";
import {
  getshoplist,
  supplierGetList,
  userPermissionShopGetList,
  userPermissionSupplierGetList,
  orderTakeouGetOrderAllInfo,
  orderTakeouGetOrderAllInfoII,
} from "@/api/basicConfiguration";
import {
  companyAccountGetList,
  userPermissionCompanyAccountGetList,
} from "@/api/purchasing";
import { upMoney } from "@/api/base";
import { getRoles } from "@/utils";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "individualOrderManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
    Freigth: () => import("../salesManagement/freigth.vue"),
    previewComponents: () => import("@/components/previewComponents"),
  },
  data() {
    return {
      showSdTotalPopover: false,
      sd_total_cost: 0,
      sd_total_freight: 0,
      sd_total_fee: 0,
      selectedRowData: null, // 存储选中的行数据
      storeManagement: [],
      storeId: "",
      count: 0,
      totalmoney: 0,
      totaldef_money: 0,
      flowmoney: 0,
      def_flowmoney: 0,
      avg_flowmoney: 0,
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        order_type: "",
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        check: true,
        operationWidth: 120,
        search: [
          {
            label: "门店",
            type: "select",
            options: [],
            key: "shop_id",
            value: "",
          },
          {
            label: "平台",
            type: "select",
            options: [
              {
                label: "美团",
                value: 7,
              },
              {
                label: "饿百",
                value: 8,
              },
              {
                label: "京东",
                value: 9,
              },
              {
                label: "POS机",
                value: 6,
              },
            ],
            key: "order_type",
          },
          {
            label: "运费平台",
            type: "select",
            options: [
              {
                label: "美团",
                value: 1,
              },
              {
                label: "麦芽田",
                value: 2,
              },
              {
                label: "其他",
                value: -1,
              }
            ],
            key: "freight_platform",
          },
          {
            label: "订单状态",
            type: "select",
            options: [
              {
                label: "正常",
                value: 0,
              },
              {
                label: "刷单",
                value: 3,
              },
              {
                label: "跳过",
                value: 4,
              },
            ],
            key: "status",
          },
          {
            label: "日期",
            type: "daterange",
            key: "create_time",
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            sortable: true,
            width: 100,
          },
          {
            label: "下单时间",
            prop: "create_time",
            sortable: true,
            width: 170,
          },
          {
            label: "门店",
            prop: "shop_name",
            width: 150,
          },
          {
            label: "平台",
            prop: "order_type",
            filter: "orderType",
            width: 100,
          },
          {
            label: "订单编号",
            prop: "order_sn",
            slot: true,
            width: 220,
          },
          {
            label: "操作人",
            prop: "user_name",
            width: 80,
          },
          {
            label: "单号",
            prop: "tableCardNo",
            width: 80,
          },
          {
            label: "数量",
            prop: "amount",
            sortable: true,
            width: 80,
          },
          {
            label: "订单金额",
            prop: "total",
            isMoney: true,
            sortable: true,
            width: 120,
          },
          {
            label: "刷单/跳过",
            slot: true,
            prop: "clickFarming",
            width: 180,
          },
          {
            label: "收款账户",
            prop: "pay_name",
            width: 200,
          },
          {
            label: "运费平台",
            prop: "freight_platform",
            align: "center",
            width: 120,
            slot: true,
          },
          {
            label: "运费支出",
            prop: "payfor_move",
            isMoney: true,
            align: "center",
            slot: true,
            width: 180,
          },
          {
            label: "订单手续费",
            prop: "sd_fee",
            isMoney: true,
            align: "center",
            slot: true,
            width: 160,
          },
          {
            label: "运费账户",
            prop: "payforMove_name",
            width: 200,
          },
          {
            label: "顾客",
            prop: "customer",
            width: 200,
          },
          {
            label: "状态",
            prop: "status",
            width: 100,
            align: "center",
            filter: "takeState",
          },
          {
            label: "备注",
            prop: "remark",
            width: 300,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      temporaryData: [],
      accountList: [],
      accountId: "",
      freightConfig: {
        visible: false,
        key: new Date().getTime(),

        data: {
          money: "",
          id: "",
          part_id: "",
          from_sn: "",
          comp_id: "",
        },
      },
      previewParams: {
        key: new Date().getTime(),
        visible: false,
        type: "individualOrderManagement",
        viewObj: [],
        code: "",
      },
      // 统计数据
      summarizeData: {
        elm_order_num: 0,
        elm_payfor_move: 0,
        elm_total_money: 0,
        elm_total_real_profit_money: 0,
        mt_order_num: 0,
        mt_payfor_move: 0,
        mt_total_money: 0,
        mt_total_real_profit_money: 0,
        order_total_avg_payfor_move: 0,
        order_total_money: 0,
        order_total_num: 0,
        order_total_payfor_move: 0,
        order_total_real_profit_money: 0,
        pos_order_num: 0,
        pos_total_money: 0,
        pos_total_real_profit_money: 0,
        sd_count_total: 0,
        sd_get_pay_price_total: 0,
        sd_pay_pay_price_total: 0,
        sd_profit_money_total: 0,
      },
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    // 初始化列表内容
    // this.getlist();
    this.getAccountList();
    this.obtainDataSource().then(() => {
      if (this.roleId == 4) {
        this.basicListconfig.searchParameters.shop_id =
          this.$store.getters.userInfo.shopId;
      }
      this.getlist(); // 先拿基础数据，在拉记录
    });
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId"]),
  },
  methods: {
    handleBatchCreation() {
      this.dynamic("batchCreation");
    },
    pushYesterdayTakeawayOrder() {
      if (!this.storeId) {
        this.$message.error("请先选择门店！");
        return;
      }
      if (this.storeId !=14 && this.storeId != 3 && this.storeId != 17) {
        this.$message.error("当前仅支持推送【上海静安店】【黄浦仓】的销售日报");
        return;
      }

      // 获取当前选中的门店名称
      const shop = this.storeManagement.find(item => item.value === this.storeId);
      const shopName = shop ? shop.label : "";

      this.$confirm(
        `请确认已完善【${shopName}】昨日外卖运费、刷单运费及刷单成本数据。是否继续推送？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        pushYesterdayOrder({ shop_id: this.storeId }).then(res => {
          if (res.code == 1) {
            this.$message.success(res.data.msg || "推送成功！");
          } else {
            this.$message.error(res.data.msg || "推送失败！");
          }
        });
      });
    },

    downloadMytLogisticsFee() {
      if (!this.storeId) {
        this.$message.error("请先选择门店！");
        return;
      }

      if (this.storeId !=14 && this.storeId != 3 && this.storeId != 17) {
        this.$message.error("当前仅支持获取【上海静安店】【黄浦仓】的麦芽田数据");
        return;
      }
      // 获取当前选中的门店名称
      downloadMytLogisticsFeeData({ shop_id: this.storeId }).then(res => {
          if (res.code == 1) {
            this.$message.success(res.data.msg || "同步成功！");
            this.getlist();
          } else {
            this.$message.error(res.data.msg || "同步失败！");
          }
      });

    },

    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    preview(row) {
      this.previewParams.code = row.order_sn;
      orderTakeoutGetOne({ id: row.id }).then((res) => {
        if (res.code == 1) {
          let data = res.order_list.map((item) => {
            item.item_number = item.item_info.item_number;
            item.total_money = this.$money(item.total_money);
            item.price_distribution = this.$money(item.price_distribution);
            return item;
          });
          this.previewParams.viewObj = [
            {
              title: "",
              type: "array",
              value: data,
              column: [
                {
                  label: "名称",
                  prop: "item_name",
                },
                {
                  label: "条码",
                  prop: "item_number",
                  width: 240,
                },
                {
                  label: "数量",
                  prop: "num",
                  width: 120,
                },
                {
                  label: "件数",
                  prop: "package_num",
                  width: 120,
                },
                {
                  label: "散数",
                  prop: "single_num",
                  width: 120,
                },
                {
                  label: "单价",
                  prop: "price_distribution",
                  width: 120,
                },
                {
                  label: "小计",
                  prop: "total_money",
                  width: 120,
                },
              ],
            },
          ];

          this.previewParams.key = new Date().getTime();
          this.previewParams.visible = true;
        } else {
          this.$message.error("获取详情失败");
        }
      });
    },
    // 关闭查看
    closeView() {
      this.previewParams.key = new Date().getTime();
      this.previewParams.visible = false;
    },
    // 保存每行运费
    saveShippingCost(row, val) {
      setPayForMove({ id: row.id, money: this.$multiplication(val) }).then(
        (res) => {
          if (res.code == 1) {
            this.$message.success("保存成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg || "保存失败");
          }
        }
      );
    },
    // 保存每行刷单支出
    saveSdCost(row, val) {
      if (!val || isNaN(Number(val))) {
        this.$message.error("请输入有效的订单手续费金额");
        return;
      }
      setPayForSdFee({ id: row.id, money: this.$multiplication(val) }).then(
        (res) => {
          if (res.code == 1) {
            this.$message.success("保存成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg || "保存失败");
          }
        }
      );
    },
    closefreightConfig() {
      this.freightConfig.visible = false;
      this.freightConfig.key = new Date().getTime();
    },
    freight(row) {
      this.freightConfig.key = new Date().getTime();
      this.freightConfig.visible = true;
      this.freightConfig.data.money = row.trans_money_self;
      this.freightConfig.data.from_sn = row.form_sn
        ? row.form_sn
        : row.order_sn;
      this.freightConfig.data.part_id = JSON.parse(getRoles()).part_id;
      this.freightConfig.data.id = row.payforMove_id;
      this.freightConfig.data.comp_id = row.comp_id;
    },
    changeShippingFee() {
      if (this.temporaryData.length == 0) {
        this.$message.error("请选择要操作的数据！");
        return;
      }
      if (!this.accountId) {
        this.$message.error("请选择要更换的账号");
        return;
      }
      let data = this.temporaryData.map((item) => {
        return {
          payForMove_id: this.accountId,
          id: item.id,
        };
      });
      upPayforMoveId({ id_array: data }).then((res) => {
        if (res.code == 1) {
          this.$message.success("更新成功！");
          this.getlist();
          return;
        } else {
          this.$message.error(res.data.msg || "更新失败");
        }
      });
    },
    waiting() {
      this.$message.success("开发中...");
    },
    handleSelectionChange(data) {
      this.temporaryData = data;
    },
    // 示例接口A请求方法
    async requestDetails(id) {
      // 模拟API请求
      return new Promise((resolve) => {
        setTimeout(() => {
          orderTakeoutGetOne({ id: id }).then((res) => {
            if (res.code == 1) {
              res.order_info[0].link_sn = res.order_info[0].order_sn;
              let data = {
                order_info: res.order_info,
                order_list: res.order_list,
                pay_list: [
                  {
                    pay_id: res.order_info[0].pay_id,
                    money: res.order_info[0].total,
                  },
                ],
              };
              resolve(data);
            } else {
              resolve(null);
            }
          });
        }, 1000);
      });
    },
    async dynamic(data) {
      if (data == "batchCreation") {
        if (this.temporaryData.length == 0) {
          this.$message.error("请选择要操作的数据！");
          return;
        }
        var flag = false;

        try {
          // 假设需要循环请求5次（可根据需求调整循环条件）
          const requestPromises = [];

          // 循环请求接口A
          for (let index = 0; index < this.temporaryData.length; index++) {
            const item = this.temporaryData[index];
            const response = await this.requestDetails(item.id);
            // 如果需要处理每次请求的结果，可以在这里添加逻辑
            // console.log(`Request A ${index + 1} completed`, response);

            // 将每次请求的Promise存入数组（如果需要收集所有结果）
            requestPromises.push(response);
          }

          // 等待所有请求完成（如果不需要收集结果可以直接用await Promise.all(requestPromises)）
          await Promise.all(requestPromises);

          console.log(
            "%c [  ]-599",
            "font-size:13px; background:pink; color:#bf2c9f;",
            requestPromises
          );
          doBatchAdd({ batchAddList: requestPromises }).then((result) => {
            if (result.code == 1) {
              this.$confirm(result.data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning",
              }).then(() => {
                if (this.temporaryData.length == index + 1) {
                  this.getlist();
                }
                return;
              });
            } else {
              this.$confirm(result.data.msg, "提示", {
                confirmButtonText: "确定",
                type: "warning",
              }).then(() => {
                if (this.temporaryData.length == index + 1) {
                  this.getlist();
                }
                flag = true;
              });
            }
          });
        } catch (error) {
          console.error("Error occurred:", error);
          // 处理错误逻辑
        }

        // for (let index = 0; index < this.temporaryData.length; index++) {
        //   const item = this.temporaryData[index];
        //   orderTakeoutGetOne({ id: item.id }).then((res) => {
        //     if (res.code == 1) {
        //       res.order_info[0].link_sn = res.order_info[0].order_sn;
        //       let data = {
        //         order_info: res.order_info,
        //         order_list: res.order_list,
        //         pay_list: [
        //           {
        //             pay_id: res.order_info[0].pay_id,
        //             money: res.order_info[0].total,
        //           },
        //         ],
        //       };
        //       orderSellBatchAdd(data).then((result) => {
        //         if (result.code == 1) {
        //           this.$confirm(result.data.msg, "提示", {
        //             confirmButtonText: "确定",
        //             type: "warning",
        //           }).then(() => {
        //             if (this.temporaryData.length == index + 1) {
        //               this.getlist();
        //             }
        //             return;
        //           });
        //         } else {
        //           this.$confirm(result.data.msg, "提示", {
        //             confirmButtonText: "确定",
        //             type: "warning",
        //           }).then(() => {
        //             if (this.temporaryData.length == index + 1) {
        //               this.getlist();
        //             }
        //             flag = true;
        //           });
        //         }
        //       });
        //     }
        //   });

        //   if (flag == true) {
        //     return;
        //   }
        // }
      }
    }, // 下载今日外卖单
    downloadTodaySTakeawayOrder() {
      if (!this.storeId) {
        this.$message.error("请先选择门店！");
        return;
      }
      let data = {
        shop_id: this.storeId,
      };
      mailAlert(data).then((res) => {
        if (res.code == 1) {
          this.$alert(res.data.msg, "提示", {
            confirmButtonText: "确定",
            callback: (action) => {},
          });
          // this.$message.success(res.data.msg || "下载成功！");
          this.getlist();
        } else {
          this.$message.error(res.data.msg || "下载失败！");
        }
      });
    },
    // 跳过操作
    skip(row) {
      this.$confirm("是否要继续操作此数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (row.status == 4) {
          orderTakeoutSetUnJump({ id: row.id }).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.getlist();
            } else {
              this.$message.error(res.data.msg || "操作失败");
            }
          });
        } else {
          orderTakeoutSetJump({ id: row.id }).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.getlist();
            } else {
              this.$message.error(res.data.msg || "操作失败");
            }
          });
        }
      });
    },
    // 刷单操作
    clickFarming(row) {

      // 判断运费支出和订单手续费都大于0
      // 仅在 shop_id 为 3 或 14 时生效

      if ((row.shop_id == 3 || row.shop_id == 14 || row.shop_id == 17 )) {
        // 目前只是针对静安店和昌平店外卖订单做运费支出校验
        if (row.order_type == 7 || row.order_type == 8 || row.order_type == 9) {
          // 判断运费是否为零或负数
          if ((Number(row.payfor_move) <= 0 ) || (Number(row.sd_fee) <= 0 )) {
            this.$message.error("本单为外卖单,运费支出与订单手续费不能为零");
            return;
          }

          // 判断运费是否已修改但未保存
          if (row.payfor_move != row.original_payfor_move) {
            this.$alert(
              `原始运费为 ${row.original_payfor_move}，当前运费为 ${Number(row.payfor_move).toFixed(2)}，列表中请点击保存运费后建单`,
              "提示",
              {
                confirmButtonText: "取消",
                type: "warning",
                callback: () => {
                  this.$message.success("操作已取消");
                },
              }
            );
            return;
          }

          // 判断订单手续费是否已修改但未保存
          if (row.sd_fee !== row.original_sd_fee) {
            this.$alert(
              `原始订单手续费为 ${Number(row.original_sd_fee).toFixed(2)}，当前订单手续费为 ${Number(row.sd_fee).toFixed(2)}，列表中请点击保存订单手续费后建单`,
              "提示",
              {
                confirmButtonText: "取消",
                type: "warning",
                callback: () => {
                  this.$message.success("操作已取消");
                },
              }
            );
            return;
          }
        }
      }

      this.$confirm("是否要继续操作此数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (row.status == 3) {
          orderTakeoutSetUnRefresh({ id: row.id }).then((res) => {
            if (res.code == 1) {
              let data = {
                comp_id: row.comp_id,
                shop_id: row.shop_id,
                pay_id: row.pay_id,
                user_id: JSON.parse(getRoles()).user_id,
                supplier_id: 0,
                customer_id: 0,
                money: Number(row.total),
                remark: `撤销外卖刷单额外收入，关联单号${row.order_sn}。`,
                flow_type: -10,
                sub_type: 1,
              };
              upMoney(data).then((result) => {
                if (result.code == 1) {
                  this.$message.success("操作成功");
                  this.getlist();
                } else {
                  this.$message.error(res.msg);
                }
              });

            } else {
              this.$message.error(res.data.msg || "操作失败");
            }
          });
        } else {
          let sd_fee_fen =  (Number(row.sd_fee)*100 );
          orderTakeoutSetRefresh({ id: row.id , sd_fee: sd_fee_fen}).then((res) => {
            if (res.code == 1) {
              let data = {
                comp_id: row.comp_id,
                shop_id: row.shop_id,
                pay_id: row.pay_id,
                user_id: JSON.parse(getRoles()).user_id,
                supplier_id: 0,
                customer_id: 0,
                money: (Number(row.total)),
                remark: `外卖刷单额外收入，关联单号${row.order_sn}`,
                flow_type: 13,
                sub_type: 0,
              };
              upMoney(data).then((result) => {
                if (result.code == 1) {
                  this.$message.success("操作成功");
                } else {
                  this.$message.error(res.msg);
                }
              });

              // 如果是静安店或徐汇店，刷单时，同时添加运费和手续费
              if(row.shop_id == 3 || row.shop_id == 14 ||row.shop_id==17){
                let sd_yf_data = {
                  comp_id: row.comp_id,
                  shop_id: row.shop_id,
                  pay_id: row.payforMove_id,
                  user_id: JSON.parse(getRoles()).user_id,
                  supplier_id: 0,
                  customer_id: 0,
                  money: (Number(row.payfor_move) *100 ),
                  remark: `外卖刷单运费支出，关联单号${row.order_sn}`,
                  flow_type: -12,
                  sub_type: 1
                };
                upMoney(sd_yf_data).then((result) => {
                  if (result.code == 1) {
                    console.log("运费添加成功");
                  } else {
                    this.$message.error(res.msg);
                  }
                });
              }
              this.getlist();

            } else {
              this.$message.error(res.data.msg || "操作失败");
            }
          });
        }
      });
    },
    // 关闭弹窗
    closeThePopUpWindow(id) {
      if (id) {
        orderSellGetList({ id: id }).then((res) => {
          if (res.code == 1) {
            this.freight(res.data[0]);
          }
        });
      }
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    creatSaleOrder(row) {
        // 目前只是针对静安店和昌平店做运费支出校验
       if ((row.shop_id == 3 || row.shop_id == 14 || row.shop_id==17) ){
           // 目前只是针对静安店和昌平店外卖订单做运费支出校验
          if (row.order_type == 7 || row.order_type == 8 || row.order_type == 9) {

            // 判断运费是否为零或着负数
            if (Number(row.payfor_move) <= 0) {
                this.$message.error("本单为外卖单,运费支出不能为零");
                return;
             }

            // 判断运费是否已修改但未保存
            if (row.payfor_move !== row.original_payfor_move) {
              this.$alert(
                `原始运费为 ${row.original_payfor_move}，当前运费为 ${Number(row.payfor_move).toFixed(2)}，列表中请点击保存运费后建单`,
                "提示",
                {
                  confirmButtonText: "取消",
                  type: "warning",
                  callback: () => {
                    this.$message.success("操作已取消");
                  },
                }
              );
              return;
            }
          }
       }

      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
      this.dialogParams.shop_id = row.shop_id;
      this.dialogParams.order_type = row.order_type;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          if (Array.isArray(data[key])) {
            console.log(
              "%c [  ]-858",
              "font-size:13px; background:pink; color:#bf2c9f;",
              key
            );
            if (data[key].length == 0) {
              console.log(
                "%c [  ]-860",
                "font-size:13px; background:pink; color:#bf2c9f;"
              );
              delete this.basicListconfig.searchParameters.begin_time;
              delete this.basicListconfig.searchParameters.end_time;
            } else {
              console.log(
                "%c [  ]-863",
                "font-size:13px; background:pink; color:#bf2c9f;"
              );
              this.basicListconfig.searchParameters.begin_time = data[key][0];
              this.basicListconfig.searchParameters.end_time = data[key][1];
            }
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;

      // 有用户门店权限的，查看只能看指定门店记录
      // 用户选中店铺时，按所选店铺查看; 未选时，按用户权限所有店面查询
      if (!this.basicListconfig.searchParameters["shop_id"]) {
        if (this.shopIds.length != 0) {
          this.basicListconfig.searchParameters["shop_id"] =
            this.shopIds.join(", ");
        }
      }

      orderTakeoutGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data.map((item) => {
            item.payfor_move = this.$money(item.payfor_move);
            item.original_payfor_move = item.payfor_move; // 记录原始运费
            item.original_sd_fee = item.sd_fee;           // 原始订单手续费
            return item;
          });
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });

      orderTakeouGetOrderAllInfoII(this.basicListconfig.searchParameters).then(
        (res) => {
          if (res.code == 1) {
            for (const key in res.data) {
              this.summarizeData[key] = res.data[key] ? res.data[key] : 0;
            }

            this.sd_total_cost = res.data.sd_total_cost || 0;
            this.sd_total_freight = res.data.sd_total_freight || 0;
            this.sd_total_fee = res.data.sd_total_fee || 0;

            // this.count = res.count;
            // this.totalmoney = res.totalmoney;
            // this.totaldef_money = res.totaldef_money;
            // this.flowmoney = res.flowmoney;
            // this.def_flowmoney = res.def_flowmoney;
            // this.avg_flowmoney = res.avg_flowmoney;
          } else {
            this.$message.error(res.data.msg || "获取汇总数据失败！");
          }
        }
      );
    },
    // 获取门店\供应商\资金账户 受权限控制
    getSupplier() {
      if (this.roleId == 4) {
        return userPermissionSupplierGetList({
          limit: 10000,
          status: 0,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "supplier_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.id + "-" + item.nick_name,
                    value: item.id,
                  };
                });
              }
            });
          } else {
            this.$message.error(res.data.msg || "获取供应商数据源失败！");
          }
        });
      } else {
        return supplierGetList({
          limit: 10000,
          status: 0,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "supplier_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.id + "-" + item.nick_name,
                    value: item.id,
                  };
                });
              }
            });
          } else {
            this.$message.error(res.data.msg || "获取供应商数据源失败！");
          }
        });
      }
    },
    // 获取数据源
    getAccountList() {
      // 依据角色获取资金账户，普通用户，受资金权限表控制
      if (this.roleId == 4) {
        userPermissionCompanyAccountGetList({
          comp_id: this.compId,
          user_id: this.userId,
          op_type: 1, // 0 查看 1 收款 2 付款
        }).then((res) => {
          if (res.code == 1) {
            this.accountList = res.data.map((item) => {
              return {
                label: item.account_name,
                value: item.account_id,
              };
            });
          } else {
            this.$message.error(res.data.msg || "获取资金账户列表数据源失败！");
          }
        });

        // 高级别角色获取全部资金账户
      } else {
        companyAccountGetList({
          comp_id: this.compId,
          limit: 10000,
          status: 0,
        }).then((res) => {
          if (res.code == 1) {
            this.accountList = res.data.map((item) => {
              return {
                label: item.account_name,
                value: item.id,
              };
            });
          } else {
            this.$message.error(res.data.msg || "获取资金账户列表数据源失败！");
          }
        });
      }
    },

    getShops() {
      if (this.roleId == 4) {
        return userPermissionShopGetList({
          comp_id: this.compId,
          user_id: this.userId,
          use_pospal: 1,
          permission_id: this.getPermissionId("销售-外卖单-查看"),
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                this.storeManagement = item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: Number(item.id),
                  };
                });
                // item.value = JSON.parse(getRoles()).shop_id;
              }
            });
          } else {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });

        // 高级别所看门店不受控制
      } else {
        return getshoplist({
          limit: 10000,
          status: 0,
          use_pospal: 1,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                this.storeManagement = item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: Number(item.id),
                  };
                });
              }
            });
          } else {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });
      }
    },

    // 获取基础数据，获取完后才能拿列表
    obtainDataSource() {
      return Promise.all([this.getShops(), this.getSupplier()]);
    },
  },
};
</script>

<style>
.el-message-box {
  width: 1200px;
}

.sd-total-popover {
  position: absolute;
  left: -240px;
  top: 0;
  z-index: 999;
  background: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  border-radius: 4px;
  padding: 10px;
  min-width: 180px;
  font-size: 13px;
}
.sd-total-popover table {
  width: 100%;
}
.sd-total-popover td {
  padding: 4px 8px;
  color: #333;
}

</style>



// WEBPACK FOOTER //
// src/views/individualOrderManagement/index.vue